import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Link from '@arcblock/www/src/components/link';

export default function NavItem(props) {
  return (
    <Div active={props.active}>
      <Link to={props.href} className="parent-link">
        {props.children}
      </Link>
      {props.subPages && (
        <div className="sub-pages">
          {props.subPages.map(({ link, title }) => (
            <Link
              key={link}
              to={link}
              className="child-link"
              target={link.indexOf('https://') === 0 ? '_blank' : '_self'}>
              {title}
            </Link>
          ))}
        </div>
      )}
    </Div>
  );
}

const Div = styled.div`
  margin-right: 24px;
  position: relative;

  .sub-pages {
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #dee2e7;
    background-color: white;
    position: absolute;
    top: 100%;
    left: 60%;
    transform: translateX(-50%);
  }

  .sub-pages {
    opacity: 0;
    visibility: hidden;
    transition-property: opacity, visibility;
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;
  }

  .parent-link {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 4px 8px;
    font-size: 18px;
    text-decoration: none;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: ${props => (props.active ? 900 : 500)};
    color: ${props => props.theme.palette.text.primary};
    &:hover {
      opacity: 0.8;
    }
  }

  .child-link {
    display: block;
    text-decoration: none;
    padding: 8px 16px;
    white-space: nowrap;
    &:hover {
      opacity: 0.8;
    }
    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  &:hover {
    z-index: 1;
    .sub-pages {
      opacity: 1;
      visibility: visible;
    }
  }

  &:last-child {
    margin-right: 0;
    .sub-pages {
      left: auto;
      right: 0;
      transform: none;
      &:before {
        left: auto;
        right: 8;
        transform: none;
      }
    }
  }
`;

NavItem.propTypes = {
  active: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  subPages: PropTypes.array.isRequired,
};
